
<div class="n-loading-container" :class="{ small: size === 's', medium: size === 'm', large: size === 'l' }">
  <div class="lds-ring" :class="{ small: size === 's', medium: size === 'm', large: size === 'l' }">
    <div :style="ringDarkStyles()" />
    <div :style="ringDarkStyles()" />
    <div :style="ringDarkStyles()" />
    <div :style="ringDarkStyles()" />
  </div>
</div>
